<app-header [user]="user()" />

<div class="www-log">
  <section class="www-log__con">
    <!--  some issue with ngxs [ngxsFormClearOnDestroy]="_isBrowser" on server side when we -->
    <form
      [formGroup]="formGroup"
      [ngxsFormClearOnDestroy]="_isBrowser"
      [ngxsFormDebounce]="20"
      [ngxsForm]="'login.form'"
      class="www-form www-log__con__form"
      appInvalidControlScroll
      [appAnimate]="'fadeInLeft'"
      [speed]="'fast'"
      novalidate
    >
      <h3 class="www-log__con__form__ti">Zaloguj się</h3>

      <div class="row">
        <div class="col-12">
          <div class="group">
            <input
              [appInputValidator]="f.username"
              [formControlName]="'username'"
              id="username"
              type="text"
              autocomplete="off"
            />
            <label for="username" class="d-flex gap-2 align-items-center">
              <svg height="12.965" viewBox="0 0 16.421 12.965" width="16.421" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                  <path
                    d="m4.433 6h11.467a1.437 1.437 0 0 1 1.433 1.433v8.6a1.437 1.437 0 0 1 -1.433 1.432h-11.467a1.437 1.437 0 0 1 -1.433-1.433v-8.6a1.437 1.437 0 0 1 1.433-1.432z"
                    transform="translate(-1.955 -5.25)"
                  />
                  <path d="m17.331 9-7.166 5.016-7.165-5.016" transform="translate(-1.955 -6.817)" />
                </g>
              </svg>
              <span>Wprowadź swój Kod Klienta</span>
            </label>
          </div>
          <app-validate-message [control]="f.username" />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div
            class="group"
            [appShowPassword]="'assets/images/icon-remove-red-eye.svg'"
            iAlt="Show password"
            [iWidth]="'19'"
            [iHeight]="'19'"
          >
            <input
              [appInputValidator]="f.password"
              [formControlName]="'password'"
              id="password"
              type="password"
              autocomplete="off"
            />
            <label for="password" class="d-flex gap-2 align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="16.421" height="15.8" viewBox="0 0 12.038 15.8">
                <path
                  d="M12.019,13.538a1.5,1.5,0,1,0-1.5-1.5A1.509,1.509,0,0,0,12.019,13.538Zm4.514-6.772h-.752v-1.5a3.762,3.762,0,1,0-7.524,0v1.5H7.5A1.509,1.509,0,0,0,6,8.272V15.8a1.509,1.509,0,0,0,1.5,1.5h9.029a1.509,1.509,0,0,0,1.5-1.5V8.272A1.509,1.509,0,0,0,16.534,6.767Zm-6.847-1.5a2.332,2.332,0,1,1,4.665,0v1.5H9.687ZM16.534,15.8H7.5V8.272h9.029Z"
                  transform="translate(-6 -1.5)"
                  stroke="none"
                />
              </svg>
              <span>Wprowadź swoje hasło</span>
            </label>
          </div>
          <app-validate-message [control]="f.password" />
        </div>

        <div class="col-12 www-log__con__form__not-rem">
          <a
            class="www-log__con__form__not-rem__a"
            [routerLink]="['/' + routeSlug.RESET_PASSWORD]"
            appGtmClick
            [layer]="{
              event: 'uaevent',
              ecommerce: 'undefined',
              eventCategory: 'login page',
              eventAction: 'select::forgot password',
              eventLabel: 'go to remind password page::' + '/' + routeSlug.RESET_PASSWORD,
              event_name: 'body_button_click',
              module_name: 'forgot password',
              cta_name: 'go to remind password page',
              link_url: '/' + routeSlug.RESET_PASSWORD,
            }"
          >
            Nie pamiętasz hasła?
          </a>
        </div>
      </div>

      <div class="row www-log__btn my-3 my-md-0">
        <div class="col-12">
          <button (click)="onLogin()" class="www-black-btn w-100"><span>Zaloguj się</span><span> ></span></button>
        </div>

        <div class="col-12 www-log__con__form__reg">
          <p class="www-log__con__form__reg__p">
            <span>Chcesz założyć konto jako Klient L’Oreal? </span>
            <a
              class="www-log__con__form__reg__p__a"
              [routerLink]="['/' + WwwRouteSlug.CONTACT]"
              appGtmClick
              [layer]="{
                event: 'uaevent',
                ecommerce: 'undefined',
                eventCategory: 'login page',
                eventAction: 'select::contact with us',
                eventLabel: 'go to contact page::' + '/' + routeSlug.RESET_PASSWORD,
                event_name: 'body_button_click',
                module_name: 'contact with us',
                cta_name: 'go to contact page',
                link_url: '/' + routeSlug.RESET_PASSWORD,
              }"
              >Skontaktuj się z nami!</a
            >
          </p>
        </div>
      </div>
    </form>

    <div class="www-log__con__rig">
      <picture>
        <source media="(max-width:402px)" srcset="assets/images/pages/login/login-banner-mb.webp" />
        <img
          class="www-log__con__rig__img h-auto"
          [priority]="true"
          alt="background"
          ngSrc="assets/images/pages/login/login-banner-ds.webp"
          [fill]="true"
        />
      </picture>
    </div>
  </section>

  <app-newsletter-section />
</div>
